import { render } from "./MfcInputContactsPeopleMultiple.vue?vue&type=template&id=51d5d316"
import script from "./MfcInputContactsPeopleMultiple.vue?vue&type=script&lang=js"
export * from "./MfcInputContactsPeopleMultiple.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__